type TokenWindow = Window & { getToken?: () => Promise<string> };

/**
 * Federated micro-apps (QR, analytics, submissions) read the auth token through
 * `window.getToken()`. The builder runs in its own iframe, so the host's global
 * never reaches it; expose the Postmate-seeded token instead. `readToken` is
 * called on every request so tokens refreshed via `updatedToken` flow through.
 */
export function installRemoteGetToken(readToken: () => string): void {
  const tokenWindow = window as TokenWindow;
  if (typeof tokenWindow.getToken === "function") return;
  tokenWindow.getToken = async () => readToken() || "";
}
